import { render, staticRenderFns } from "./AppNavbar4.vue?vue&type=template&id=68454060&scoped=true"
import script from "./AppNavbar4.vue?vue&type=script&lang=ts"
export * from "./AppNavbar4.vue?vue&type=script&lang=ts"
import style0 from "./AppNavbar4.vue?vue&type=style&index=0&id=68454060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68454060",
  null
  
)

export default component.exports